/* eslint-disable @typescript-eslint/ban-types */
import React, { FC, HTMLAttributes, PropsWithChildren } from 'react';
import { styled } from 'linaria/react';
import { defaultTheme, withTheme } from '@shared/lib/theme';
interface TextButtonProps extends HTMLAttributes<HTMLSpanElement> {
  color?: keyof typeof defaultTheme['colors']['text'] | (string & {});
  hoverColor?: keyof typeof defaultTheme['colors']['text'] | (string & {});
  onClick?: () => void;
  disabled?: boolean;
}
const TextButton: FC<PropsWithChildren<TextButtonProps>> = ({
  children,
  color = 'accent',
  hoverColor = 'accent',
  ...props
}) => <TextButtonWrapper color={color} hoverColor={hoverColor} {...props}>
    {children}
  </TextButtonWrapper>;
export default TextButton;
const _exp2 = /*#__PURE__*/() => ({
  color,
  theme
}) => color in theme.colors.text ? theme.colors.text[color] : color;
const _exp4 = /*#__PURE__*/() => ({
  hoverColor,
  theme
}) => hoverColor in theme.colors.text ? theme.colors.text[hoverColor] : hoverColor;
const _exp5 = /*#__PURE__*/() => ({
  hoverColor,
  theme
}) => hoverColor in theme.colors.text ? theme.colors.text[hoverColor] : hoverColor;
const _exp6 = /*#__PURE__*/() => ({
  hoverColor,
  theme
}) => hoverColor in theme.colors.text ? theme.colors.text[hoverColor] : hoverColor;
const TextButtonWrapper = withTheme(/*#__PURE__*/styled('span')({
  name: "TextButtonWrapper",
  class: "t149zziu",
  propsAsIs: false,
  vars: {
    "t149zziu-0": [_exp2()],
    "t149zziu-1": [_exp6()],
    "t149zziu-2": [_exp4()],
    "t149zziu-3": [_exp5()]
  }
}));

require("./TextButton.linaria.module.css!=!../../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./TextButton.tsx");